module.exports = __webpack_public_path__ + "img/chevron-right.836467cb.svg";